export class UserInfo {
    public xLoginUName: string;
    public xHashedPwd: string;

    constructor(obj?) {
        this.xLoginUName = (obj && obj.xLoginUName) || "";
        this.xHashedPwd = (obj && obj.xHashedPwd) || "";
    }
}
